import { IOrg } from "../ConfigService";

export interface ISession {
    userName: string;
    emailAddress: string;
    fullName: string;
    accountManagerId?: string;
    token?: string;
    loggedOut?: boolean;
    errorMessage?: string;
    loggedin?: boolean;
    userId: string;
    myOrgId: string;
    myClientId: string;
    orgArray: Array<orgIds>;
    clientArray: Array<IClientSpocsClient>;
    roles: [];
    authenticated?: boolean;
    salesRepId?: string;
    profilePicUrl?: string;
    orgDetails: IOrg;
    clientDeatils: IClientSpocsClient;
    authCallMade: boolean;
    employeeId?: string;
}

export interface orgIds {
    orgId: string;
    orgName: string;
    orgDesc: string;
    orgType: string;
}

export interface IClientSpocsClient {
    clientId: string;
    clientName: string;
    orgId: string;
    isActive: boolean;
    createDateTime: string;
}

export enum Role {
    Admin = 'Admin',
    SettingsAdmin = 'SettingsAdmin', 
    Payroll = 'Payroll',
    OffshoreHr = 'OffshoreHr',
    OffshorePayroll = 'OffshorePayroll',
    Contracts = 'Contracts',
    Hr = 'Hr',
    Sales = 'Sales',
    SalesRep = 'SalesRep',
    BenchSales = 'BenchSales',
    Property = 'Property',
    LeadRep = 'LeadRep',
    ExternalTimeApproval = 'ExternalTimeApproval',
    HMManager = 'HMManager',
    HMUser = 'HMUser',
    ReportingManager='ReportingManager',
    AntipasAdmin='AntipasAdmin'
}

export interface INewProfilePic {
    orgId?: string;
    userId?: string;
    files: File;
}